<template>
  <dc-layout-main>
    <dc-layout-content>
      <baseMessage type="add" :permissionPage="permissionBasic"/>
    </dc-layout-content>
  </dc-layout-main>
</template>
<script setup lang="ts">
import baseMessage from './components/baseMessage.vue'
const permissionBasic = {
  save: 'lbu_accompanying_visit_add_btn'
}
</script>
<script lang="ts">
export default { name: 'DcCosLbuSupervisorAccompanyingVisitAdd' }
</script>
